import { render } from "./ReloadView.vue?vue&type=template&id=4f5a86c2&scoped=true"
import script from "./ReloadView.vue?vue&type=script&lang=js"
export * from "./ReloadView.vue?vue&type=script&lang=js"

import "./ReloadView.vue?vue&type=style&index=0&id=4f5a86c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5a86c2"]])

export default __exports__